import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';
import { getCategoryCount } from '@/lib/queries';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategoryGrid() {
  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="Browse by genre"
        title="分类快速入口"
        description="按题材浏览收录影片，每个分类都配有独立的筛选与排序功能，帮你更快定位想看的内容。"
      />

      <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex cursor-pointer flex-col justify-between rounded-lg border border-background-800 bg-background-900 p-4 transition-colors hover:border-primary-500 md:p-5"
          >
            <div className="flex items-start justify-between">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-950 text-primary-300 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${category.icon} text-base`} />
              </span>
              <span className="font-label text-[11px] tracking-[0.14em] text-foreground-600">
                {String(getCategoryCount(category.slug)).padStart(2, '0')}
              </span>
            </div>
            <div className="mt-6">
              <p className="text-sm font-semibold text-foreground-100 transition-colors group-hover:text-accent-400">
                {category.name}
              </p>
              <p className="mt-1 font-label text-[10px] uppercase tracking-[0.18em] text-foreground-600">
                {category.en}
              </p>
              <p className="mt-2 hidden text-xs leading-relaxed text-foreground-500 lg:block">{category.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}